<template>
  <div class="my-login-form">
    <div class="tab-switch">
      <div
        v-show="activeIndex !== 3"
        class="tab-switch-item"
        :class="{ active: activeIndex === 1 }"
        @click="handleTabSwitch(1)"
      >
        登录
      </div>
      <div
        v-show="activeIndex !== 3"
        class="tab-switch-item"
        :class="{ active: activeIndex === 2 }"
        @click="handleTabSwitch(2)"
      >
        注册
      </div>
      <div class="tab-switch-item" v-show="activeIndex === 3">
        重置密码
      </div>
    </div>
    <div class="login-form-content" v-show="activeIndex === 1">
      <div class="login-form-lable">
        用户名/手机号
      </div>
      <el-input class="login-form-input" v-model="loginForm.username" auto-complete="false">
      </el-input>
      <div class="login-form-lable">
        密码
      </div>
      <el-input
        class="login-form-input"
        v-model="loginForm.password"
        ref="passwordInput"
        :type="inputType"
        auto-complete="false"
      >
        <!-- 密码隐藏图标 -->
        <template v-slot:suffix>
          <img
            :src="suffixIcon"
            @click="changeShowPassword"
            class="suffix-image"
          />
        </template>
      </el-input>
      <div class="password-options" style="margin-top:25px">
        <el-checkbox
          v-model="checkLogin"
          class="password-options-checkbox"
          >登录即同意<div class="box-inline" @click="openPdf(1)">《用户协议》</div>和<div class="box-inline" @click="openPdf(2)">《隐私协议》</div></el-checkbox
        >
      </div>
      <div class="password-options" style="margin:10px 0">
        <el-checkbox
          v-model="loginForm.rememberPassword"
          class="password-options-checkbox"
          >记住密码</el-checkbox
        >
        <div>
          <span class="password-options-link" @click="activeIndex = 3">忘记密码?</span>
          /
          <span class="password-options-link" @click="jumpChangePassword"
            >修改密码</span
          >
        </div>
      </div>
      <div class="login-button-wrapper">
        <el-button
          data-warden-title="用户登录"
          class="login-button"
          @click="handleLogin"
          v-if="!logining"
          :disabled="!checkLogin"
        >
          <span class="inner-text">登录</span>
        </el-button>
        <button class="login-button" v-else>
          <i class="el-icon-loading"></i>
        </button>
        <span class="login-tip" @click="vistorLogin">游客登录</span>
      </div>
    </div>
    <div
      class="login-form-content register-form-content"
      v-show="activeIndex === 2"
    >

    <el-form :model="registerForm" :rules="rules" ref="ruleForm" label-width="80px">
        <el-form-item label="用户名" prop="userName">
            <el-input v-model="registerForm.userName"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
            <el-input v-model="registerForm.password" placeholder="请输入密码（仅字母、数字及半角符号）"
            @input="val => registerForm.password = filterPassword(val)"></el-input>
            <password-strength-bar
              v-if="isPasswordValid(registerForm.password)"
              class="password-strength-bar"
              ref="passwordStrengthBarForRegister"
              :password="registerForm.password"
            />
        </el-form-item>
        <el-form-item label="确认密码" prop="checkPassword">
            <el-input v-model="registerForm.checkPassword" @input="val => registerForm.checkPassword = filterPassword(val)"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone" >
            <el-input v-model="registerForm.phone" class="phone_input"></el-input>
            <button type="button" class="send-button" @click="sendPhoneCode" :disabled="registerForm.phoneCodeWaitingTime > 0">
              {{ registerForm.phoneCodeWaitingTime > 0 ? registerForm.phoneCodeWaitingTime + 's后重新发送' : '发送验证码' }}
            </button>
        </el-form-item>
        <el-form-item label="验证码" prop="checkWord">
            <el-input v-model="registerForm.checkWord"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="notes">
            <el-input v-model="registerForm.notes"></el-input>
        </el-form-item>
    </el-form>
    <div class="password-options" style="margin-top:5px">
        <el-checkbox
          v-model="checkRegister"
          class="password-options-checkbox"
          >登录即同意<div class="box-inline" @click="openPdf(1)">《用户协议》</div>和<div class="box-inline" @click="openPdf(2)">《隐私协议》</div></el-checkbox
        >
      </div>
      <el-button
          data-warden-title="用户注册"
          class="login-button register-button"
          @click="handleRegister"
          :disabled="!checkRegister"
        >
          <span class="inner-text">注册</span>
        </el-button>
      <!-- <button class="login-button register-button" @click="handleRegister">
        <span class="inner-text">注册</span>
      </button> -->
    </div>

    <div
      class="login-form-content register-form-content"
      v-show="activeIndex === 3"
    >
      <el-form :model="findPasswordForm" :rules="rules" ref="findPasswordForm" label-width="80px">
          <el-form-item label="新密码" prop="password">
              <el-input v-model="findPasswordForm.password" placeholder="请输入密码（仅字母、数字及半角符号）"
              @input="val => findPasswordForm.password = filterPassword(val)"></el-input>
              <password-strength-bar
                v-if="isPasswordValid(findPasswordForm.password)"
                class="password-strength-bar"
                ref="passwordStrengthBarForFindPassword"
                :password="findPasswordForm.password"
              />
          </el-form-item>
          <el-form-item label="确认密码" prop="checkPassword">
              <el-input v-model="findPasswordForm.checkPassword" @input="val => findPasswordForm.checkPassword = filterPassword(val)"></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="phone" >
              <el-input v-model="findPasswordForm.phone" class="phone_input"></el-input>
              <button type="button" class="send-button" @click="sendPhoneCode" :disabled="findPasswordForm.phoneCodeWaitingTime > 0">
                {{ findPasswordForm.phoneCodeWaitingTime > 0 ? findPasswordForm.phoneCodeWaitingTime + 's后重新发送' : '发送验证码' }}
              </button>
          </el-form-item>
          <el-form-item label="验证码" prop="checkWord">
              <el-input v-model="findPasswordForm.checkWord"></el-input>
          </el-form-item>
      </el-form>
      <button class="login-button register-button" @click="handleResetPassword">
        <span class="inner-text">重置</span>
      </button>
      <div class="return-login" @click="activeIndex = 1">返回登录</div>
    </div>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      :modal="false"
      top="2vh"
      width="80%"
      class="dialogLogin"
    >
      <iframe id="pdfIframe" style="width: 100%; height: 500px;" :src="pdfUrl" :title="dialogTitle" :name="dialogTitle"></iframe>
      <!-- <pdf :src="cc"></pdf> -->
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import PasswordStrengthBar from './PasswordStrengthBar.vue'
import pdf from 'vue-pdf'
import CryptoJS from 'crypto-js'
export default {
  name: 'LoginForm',
  components: {PasswordStrengthBar, pdf},
  props: {
    type: {
      type: String,
      default: 'login'
    },
    logining: {
      type: Boolean,
      default: false
    }
  },
  data () {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        // if (/^[0-9]{8,}$/g.test(value) || /^[a-zA-Z]{8,}$/g.test(value) || /^_{8,}$/g.test(value)) {
        //   callback(new Error('密码应为8~20位字符，必须包含数字、字母、下划线中的两种以上两次输入密码不一致!'))
        // } else {
        //   callback()
        // }
        let message
        if (this.activeIndex === 2) {
          message = this.$refs.passwordStrengthBarForRegister.checkPassword()
        } else {
          message = this.$refs.passwordStrengthBarForFindPassword.checkPassword()
        }
        if (message) {
          callback(new Error(message))
        } else {
          callback()
        }
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== (this.activeIndex === 2 ? this.registerForm.password : this.findPasswordForm.password)) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    var phoneCheck = (rule, value, callback) => {
      // let reg = /^[1][3,4,5,6,7,8][0-9]{9}$/
      let reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
      if (value === '') {
        callback(new Error('请输入手机号'))
      } else if (!reg.test(value)) {
        callback(new Error('请输入正确的手机号!'))
      } else {
        callback()
      }
    }
    return {
      loginForm: {
        username: '',
        password: '',
        rememberPassword: false
      },
      loginRules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      },
      registerForm2: [
        {
          id: 1,
          label: '用户名',
          name: 'userName',
          value: '',
          required: true
        },

        {
          id: 2,
          label: '密码',
          name: 'password',
          value: '',
          required: true
        },
        {
          id: 3,
          label: '确认密码',
          name: 'checkPassword',
          value: '',
          required: true
        },
        {
          id: 4,
          label: '手机号',
          value: '',
          name: 'phone',
          required: true,
          half: true
        },
        {
          id: 5,
          label: '验证码',
          name: 'words',
          value: '',
          required: true
        },
        {
          id: 6,
          label: '备注',
          name: 'note',
          value: '',
          required: false
        }
      ],
      registerForm: {
        userName: '',
        password: '',
        checkPassword: '',
        phone: '',
        checkWord: '',
        notes: '',
        phoneCodeWaitingTime: 0
      },
      findPasswordForm: {
        password: '',
        checkPassword: '',
        checkWord: '',
        phoneCodeWaitingTime: 0
      },
      rules: {
        userName: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { 
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error('请输入用户名'));
                return;
              }
              // 计算长度：英文/数字/符号算1，中文算1.5
              const c = (value.match(/[^\x00-\xff]/g) || []).length;
              const len = value.length + c * 0.5;
              if (len < 3) {
                callback(new Error('长度至少3个字符或2个汉字'));
              } else if (len > 18) {
                callback(new Error('长度不能超过18个字符或12个汉字'));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { 
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error('请输入密码'));
                return;
              }
              // 只允许：大小写字母、数字、以及常见符号 !@#$%^&*()_+-=[]{}|;:,.<>?~
              if (!this.passwordRegex.test(value)) {
                callback(new Error('密码只能包含字母、数字和空格外的常见符号'));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ],
        checkPassword: [
          { required: true, trigger: 'blur', validator: validatePass2 }
        ],
        phone: [
          { required: true, trigger: 'blur', validator: phoneCheck }
        ],
        checkWord: [
          { required: true, trigger: 'blur', message: '请输入验证码' }
        ]
      },
      activeIndex: 1,
      inputType: 'password',
      hideIcon: require('@/assets/images/userPage/hide.png'),
      showIcon: require('@/assets/images/userPage/show.png'),
      suffixIcon: require('@/assets/images/userPage/hide.png'),
      checkLogin: false,
      checkRegister: false,
      dialogVisible: false,
      pdfUrl: '',
      dialogTitle: '',
      passwordRegex: /^[A-Za-z0-9!@#$%^&*()_+\-=[\]{}|;:,.<>?~]+$/,
    }
  },
  mounted () {
    if (this.type === 'register') {
      this.activeIndex = 2
    }
    if (this.type === 'login') {
      this.activeIndex = 1
    }
    if (localStorage.getItem('username') && localStorage.getItem('password')) {
      this.loginForm.username = localStorage.getItem('username')
      this.loginForm.password = localStorage.getItem('password')
      this.loginForm.rememberPassword = true
    }
  },
  methods: {
    handleLogin () {
      this.$emit('login', this.loginForm)
    },
    handleTabSwitch (index) {
      this.activeIndex = index
    },
    changeShowPassword () {
      if (this.inputType === 'password') {
        this.inputType = 'text'
        this.suffixIcon = this.showIcon
      } else {
        this.inputType = 'password'
        this.suffixIcon = this.hideIcon
      }
    },
    jumpChangePassword () {
      this.$router.push('/changePasswordWithUsername')
    },
    vistorLogin () {
      this.$emit('login', {
        username: 'anonymity',
        password: 'user_password',
        webUrl: this.$route.params.url,
        rememberPassword: false
      })
      this.$router.replace('/home')
    },
    sendPhoneCode () {
      const phone = this.activeIndex === 2 ? this.registerForm.phone : this.findPasswordForm.phone
      let reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
      if (phone === '') {
        this.$message.error('请输入手机号！')
        return
      } else if (!reg.test(phone)) {
        this.$message.error('请输入正确的手机号！')
        return
      }
      const params = new URLSearchParams()
      params.append('url', this.activeIndex === 2 ? 'user/sendPhoneCodeForRegister' : 'user/sendPhoneCodeForFindPassword')
      params.append(
        'param',
        JSON.stringify({
          phone: phone
        }))
      this.$http.post('retrieve/feignInterface/invokeUserInterface', params).then(response => {
        if (response.data.status === 200) {
          this.$message.success('验证码发送成功')
          const currentForm = this.activeIndex === 2 ? this.registerForm : this.findPasswordForm
          currentForm.phoneCodeWaitingTime = 60
          let clock = window.setInterval(() => {
            currentForm.phoneCodeWaitingTime--
            if (currentForm.phoneCodeWaitingTime <= 0) {
              window.clearInterval(clock)
            }
          }, 1000)
        }
      })
    },
    handleRegister () {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          const params = new URLSearchParams()
          params.append('url', 'user/register')
          params.append(
            'param',
            JSON.stringify({
              username: this.registerForm.userName,
              password: CryptoJS.MD5(this.registerForm.password).toString(),
              phone: this.registerForm.phone,
              code: this.registerForm.checkWord,
              note: this.registerForm.notes
            }))
          this.$http.post('retrieve/feignInterface/invokeUserInterface', params).then(response => {
            if (response.data.status === 200) {
              this.$emit('register-success', this.registerForm)
              this.activeIndex = 1
            }
          })
        }
      })
    },
    handleResetPassword () {
      this.$refs.findPasswordForm.validate(valid => {
        if (valid) {
          const params = new URLSearchParams()
          params.append('url', 'user/resetPasswordByPhone')
          params.append(
            'param',
            JSON.stringify({
              password: CryptoJS.MD5(this.findPasswordForm.password).toString(),
              phone: this.findPasswordForm.phone,
              code: this.findPasswordForm.checkWord
            }))
          this.$http.post('retrieve/feignInterface/invokeUserInterface', params).then(response => {
            if (response.data.status === 200) {
              this.$message.success('密码重置成功，请登录')
              setTimeout(() => {
                window.location.reload()
              }, 700)
            }
          })
        }
      })
    },
    toLogin (tempForm) {
      if (tempForm) {
        this.loginForm.username = tempForm.userName
        this.loginForm.password = ''
        this.activeIndex = 1
      }
    },
    openPdf (index) {
      // 设置新的src，触发加载
      if (index === 1) {
        this.pdfUrl = require('@/assets/pdf/用户协议.pdf')
        this.dialogTitle = '用户协议'
      } else {
        this.pdfUrl = require('@/assets/pdf/隐私政策.pdf')
        this.dialogTitle = '隐私政策'
      }
      this.dialogVisible = true
    },
    isPasswordValid(password) {
      if (!password) {
          return false;
      }
      return this.passwordRegex.test(password);
    },
    filterPassword(val) {
      return val.replace(/[^A-Za-z0-9!@#$%^&*()_+\-=[\]{}|;:,.<>?~]/g, '');
    }
  }
}
</script>

<style scoped>
.my-login-form {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.tab-switch {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 70px;
  border-bottom: 1px solid #f5eee8;
  font-size: 18px;
}

.tab-switch-item {
  width: 30%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  color: #634c37;
}

.tab-switch-item.active {
  color: #9e5c1d;
  border-bottom: 1px solid #9e5c1d;
  font-weight: bold;
}

.login-form-content {
  margin-top: 30px;
  width: 400px;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.login-form-content >>> .el-input__inner {
  height: 40px;
  border: 1px solid #634c37;
  border-radius: 0;
  color: #634c37;
  font-size: 14px;
  padding: 0 25px;
}

.login-form-content >>> .el-input__inner:hover {
  border: 1px solid #9e5c1d;
}

.login-form-content >>> .el-input__inner:focus {
  border: 1px solid #9e5c1d;
}

.login-form-lable {
  width: 400px;
  height: 40px;
  text-align: left;
  line-height: 40px;
  font-size: 14px;
  color: #634c37;
  padding-left: 20px;
}

.password-options {
  width: 318px;
  /* height: 40px; */
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* margin-top: 30px; */
}

.my-login-form >>> .el-checkbox {
  display: flex;
  justify-content: center;
  align-items: center;
}

.password-options-checkbox >>> .el-checkbox__inner {
  border: 1px solid #634c37;
  border-radius: 0;
}

.password-options-checkbox >>> .el-checkbox__label {
  color: #634c37;
}

.password-options-checkbox
  >>> .el-checkbox__input.is-checked
  .el-checkbox__inner,
.password-options-checkbox
  >>> .el-checkbox__input.is-indeterminate
  .el-checkbox__inner {
  background-color: #9e5c1d;
  border-color: #9e5c1d;
}
.phone_input{
width: 190px;
}
.password-options-link {
  font-size: 14px;
  color: #634c37;
  cursor: pointer;
}

.login-button {
  width: 300px;
  height: 40px;
  font-size: 18px;
  background-color: #9e5c1d;
  border: none;
  border-radius: 0;
  color: #fff;
  cursor: pointer;
  margin-left: 55px;
}

.inner-text {
  display: inline-block;
  width: 50px;
  text-align: justify;
  text-align-last: justify;
}

.register-form-content {
  margin-top: 20px;
}

.register-form-item {
  width: 350px;
  height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 7px;
}

.is-necessary {
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 10px;
  min-height: 10px;
  border-radius: 50%;
  margin-right: 10px;
}

.register-form-lable {
  width: 60px;
  text-align: justify;
  text-align-last: justify;
  font-size: 14px;
  color: #634c37;
  margin-right: 5px;
  flex-shrink: 0;
}

.star {
  width: 10px;
}

.send-button {
  display: inline-block;
  width: 110px;
  margin-left: 10px;
  height: 40px;
  font-size: 14px;
  background-color: #9e5c1d;
  border: none;
  border-radius: 0;
  color: #fff;
  cursor: pointer;
}

.send-button:disabled {
  cursor: not-allowed;
}

.register-button {
  width: 350px;
  margin: 30px 0 44px 0;
}

.login-loading {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.5);
  z-index: 100;
}

.my-login-form >>> .el-input__suffix {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.my-login-form >>> .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #634c37;
}

.login-button-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
}

.login-tip {
    font-size: 14px;
    width: 70px;
    margin-left: 5px;
    color: #634c37;
    cursor: pointer;
}

.return-login {
  color: #634c37;
  margin-bottom: 20px;
  cursor: pointer;
}

.password-strength {
  margin-bottom: 5px;
}
.box-inline{
    display: inline-flex;
    color: blue;
}
.dialogLogin{
    z-index: 9999 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/LoginForm.vue